import type { GridFilterInputValueProps } from '@mui/x-data-grid';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import dayjs, { type Dayjs } from 'dayjs';

// Filter input that renders a MUI DatePicker instead of the default text field.
// Stores the selected value as a 'YYYY-MM-DD' string to stay compatible with the
// grid's date-filter logic.
const DateFilterInput = ({ item, applyValue, focusElementRef }: GridFilterInputValueProps) => {
  const value = item.value ? dayjs(item.value as string) : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        value={value}
        onChange={(date: Dayjs | null) =>
          applyValue({ ...item, value: date?.isValid() ? date.format('YYYY-MM-DD') : undefined })
        }
        slotProps={{
          textField: {
            variant: 'outlined',
            size: 'small',
            inputRef: focusElementRef,
            label: 'Value',
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default DateFilterInput;
